import "../styles/Home.css"
import IconList from "../components/IconList";
import myPhoto from '../assets/img/my-pic.jpeg';
import { useLanguage } from "../helpers/LanguageContext";
import { translations } from "../helpers/translations";
import { Link } from "react-router-dom";
import logo from "../assets/img/logo.jpg"
import { Email, GitHub, LinkedIn } from "@mui/icons-material";

function Home() {
    const { language } = useLanguage();
    const t = translations[language].home;

    return (
        <div className="home">
            {/* Hero Section */}
            <section className="hero-section">
                <div className="hero-content">
                    <h1 className="hero-name">Antonio Fiocco</h1>
                    <div className="hero-role-container">
                        <p className="hero-role">{t.role}</p>
                    </div>
                    <div className="hero-socials">
                        <LinkedIn className="social-icon" onClick={() => window.open("https://www.linkedin.com/in/fiocco-antonio", "_blank")} />
                        <Email className="social-icon" onClick={() => window.open("mailto:antonio18fiocco@gmail.com", "_blank")} />
                        <GitHub className="social-icon" onClick={() => window.open("https://github.com/therealfiiocco", "_blank")} />
                    </div>
                </div>
                <div className="hero-logo">
                    <img src={logo} alt="Logo" />
                </div>
            </section>

            {/* About Section */}
            <div className="starry-background">
                <section className="about-me-section">
                    <div className="glass-card">
                        <h2 className="section-title">{t.aboutSection.title}</h2>
                        <div className="about-content">
                            <img src={myPhoto} alt="Antonio Fiocco" className="about-profile-img" />
                            <div className="about-text">
                                <p dangerouslySetInnerHTML={{ __html: t.aboutSection.p1 }}></p>
                                <p dangerouslySetInnerHTML={{ __html: t.aboutSection.p2 }}></p>
                                <p dangerouslySetInnerHTML={{ __html: t.aboutSection.p3 }}></p>
                                <p dangerouslySetInnerHTML={{ __html: t.aboutSection.p4 }}></p>
                            </div>
                        </div>
                        <div className="about-action">
                            <Link to="/about-me" className="btn-primary">{t.aboutSection.button}</Link>
                        </div>
                    </div>
                </section>
            </div>

            {/* Skills Section */}
            <section className="skills-section">
                <h1 className="section-title">{t.skills}</h1>
                <IconList />
            </section>
        </div>
    )
}

export default Home